module.exports = __webpack_public_path__ + "img/red1.f6729f33.jpg";